import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsInstalledBase = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <path
          fill="currentColor"
          d="M0.9483033,14.6142483L11.7211142,18.42239
	c0.0868349,0.0323563,0.1824207,0.0323563,0.2692566,0l10.772809-3.8081427
	c0.2097511-0.073247,0.3204079-0.3026628,0.2471581-0.5124121c-0.0404186-0.1157446-0.1314125-0.2067404-0.2471581-0.24716
	l-3.4058628-1.203619l2.0563717-0.7274408c0.2097492-0.0732479,0.3204079-0.3026628,0.2471581-0.512413
	c-0.0404186-0.1157446-0.1314144-0.2067394-0.2471581-0.247159l-3.4058647-1.20362l2.0563717-0.7274408
	c0.2097511-0.0732479,0.3204079-0.3026628,0.24716-0.5124121c-0.0404205-0.1157455-0.1314144-0.2067404-0.24716-0.24716
	L11.989728,5.6169844c-0.087307-0.0296249-0.1819487-0.0296249-0.2692566,0l-8.0789652,2.85707
	C3.4317563,8.5473013,3.321099,8.7767162,3.3943465,8.9864664c0.0404198,0.1157446,0.1314149,0.2067404,0.2471597,0.24716
	l2.0563703,0.7274408l-3.4058638,1.203619c-0.2097499,0.0732479-0.3204072,0.3026628-0.2471595,0.512413
	c0.0404198,0.1157446,0.1314149,0.2067394,0.2471595,0.247159l2.0563703,0.7274408l-3.4058635,1.20362
	c-0.20975,0.073247-0.3204071,0.3026628-0.2471595,0.5124121c0.0404196,0.1157446,0.1314148,0.2067404,0.2471595,0.24716
	L0.9483033,14.6142483z M18.7236996,8.8486996l-6.8676357,2.4290867L4.9852157,8.8486996l6.8676353-2.4290881L18.7236996,8.8486996z
	 M11.7217569,12.0849123c0.0868359,0.0323572,0.1824217,0.0323572,0.2692566,0l4.8106222-1.6997185l3.2696285,1.1567078
	L11.8567057,14.44524l-8.2145567-2.9033384l3.2709143-1.1554232L11.7217569,12.0849123z M11.7217569,15.2549362
	c0.0868359,0.0323572,0.1824217,0.0323572,0.2692566,0l6.1569033-2.1758966l3.2696304,1.1567087l-9.5608387,3.3801594
	l-9.5614824-3.3833733l3.2696292-1.1567087l6.1569018,2.1758966V15.2549362z"
        />
      </SvgIcon>
    );
  }
);

export default AppIconsInstalledBase;
